import { Cache } from "memory-cache";
import { CorpAssetEntity } from ".";
// Cache
const cache = new Cache();

export async function getCachedCorpAssetEntity(asset_id: number): Promise<CorpAssetEntity | null> {
  let entity: any = await cache.get(asset_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}

export function setCachedCorpAssetEntity(asset: CorpAssetEntity) {
  cache.put(asset.props.item_id.toString(), asset, 60 * 60 * 1000 /* 1 hour */);
}
